import React from 'react';

const WarrantyPolicy = () => {
    return (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
            <h1 className="text-3xl font-extrabold text-gray-900">Warranty Policy :</h1>
            <p className="mt-4 text-lg text-gray-500 leading-loose text-justify">
                Warranty service will be provided directly by the seller who has sold the product through We Hatbazar. The terms and conditions of this warranty may differ from seller to seller. We Hatbazar does not take any responsibility for after-sales services provided by the supplier/manufacturer. Customers may contact with the seller for after sales service or warranty claim via We Hatbazar by contacting We Hatbazar’s customer support center to submit the products for repair/replacement under the warranty conditions.
            </p>
        </div>
    );
};

export default WarrantyPolicy;